import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { Icon } from 'libs.nucleus';
export const FamilyExpandContext = createContext(null);
const siblingContentId = (id) => `consent-template-version-${id}`;
export const FamilyExpandToggle = ({ row }) => {
    const familyExpand = useContext(FamilyExpandContext);
    if (!familyExpand) {
        return null;
    }
    const { expandedFamilyIds, toggleFamily, translate } = familyExpand;
    if (!row.expandableFamily) {
        return (_jsx("span", { className: 'nucleus-inline-flex nucleus-w-5 nucleus-h-5 nucleus-shrink-0', id: row.familyParentId ? siblingContentId(row.id) : undefined, "data-testid": 'consent-template-expand-spacer', "aria-hidden": true }));
    }
    const isExpanded = expandedFamilyIds.has(row.id);
    const ariaControls = (row.familySiblingIds ?? []).map(siblingContentId).join(' ');
    return (_jsx("button", { type: 'button', "aria-expanded": isExpanded, "aria-controls": ariaControls || undefined, "aria-label": translate(isExpanded ? 'Hide other versions' : 'Show other versions'), "data-testid": `consent-template-expand-${row.id}`, onClick: (event) => {
            event.stopPropagation();
            toggleFamily(row.id);
        }, className: 'nucleus-flex nucleus-items-center nucleus-justify-center nucleus-shrink-0 nucleus-cursor-pointer nucleus-bg-transparent nucleus-border-0 nucleus-p-0', children: _jsx("span", { className: `nucleus-flex nucleus-transition-transform nucleus-duration-200 ${isExpanded ? 'nucleus-rotate-90' : ''}`, children: _jsx(Icon, { name: 'chevronRightMini', size: 20 }) }) }));
};
